import { useContext, useEffect, useRef, useState } from 'react'
import { Form } from '@unform/web'
import { Toggle, Path } from 'components/index'
import { UserContext } from 'context/userContext'
import { Container } from './style'
import PF from './PF'
import PJ from './PJ'

export default function NovaConta() {
  const { formData } = useContext(UserContext)
  const formRef = useRef<HTMLFormElement | any>(null)
  const [toggleForm, setToggleForm] = useState<string>('')
  const toggleOptionList = [
    ['Pessoa Física', 'pf'],
    ['Pessoa Jurídica', 'pj'],
  ]

  useEffect(() => {
    formData.current = new FormData()
  }, [toggleForm])

  return (
    <Container>
      <Path className="path">
        <span className="path">{'Gestão do cliente > Novo cliente'}</span>
      </Path>
      <Form ref={formRef} onSubmit={() => null}>
        <div>
          <h1 className="new-colaborator-title">Cadastrar cliente</h1>
          <div className="new-colaborator-toggle">
            <Toggle
              options={toggleOptionList}
              toggle={toggleForm}
              setToggle={setToggleForm}
            />
          </div>
          {toggleForm === 'pf' ? <PF /> : <PJ />}
        </div>
      </Form>
    </Container>
  )
}
